import * as React from "react";
import {memo} from "react";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {Teal} from "orpyx-web-common";
import {IGetPatientInformationResponse} from "doctors-dashboard/http-clients/index";
import {ORPYX_PORTAL_URL} from "../../../../../../../appConstants";

export interface PatientPortalLinkProps {
    readonly patient: IGetPatientInformationResponse;
}

const usePatientPortalLinkStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        alignSelf: 'flex-start',

        margin: '10px 0 0 6px',
        padding: '5px 14px',

        border: '1px solid rgba(255, 255, 255, 0.7)',
        borderRadius: '16px',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',

        color: '#fff',
        fontSize: '13px',
        fontWeight: 'bold',
        letterSpacing: '0.3px',
        whiteSpace: 'nowrap',
        textDecoration: 'none',

        transition: 'background-color 150ms ease, color 150ms ease, border-color 150ms ease',

        '&:hover': {
            backgroundColor: '#fff',
            borderColor: '#fff',
            color: Teal,
        },
        '&:focus': {
            outline: '2px solid #fff',
            outlineOffset: '2px',
        },
    },

    icon: {
        fontSize: '15px',
        marginLeft: '7px',
    },
}));

const portalPatientUrl = (patient: IGetPatientInformationResponse): string | undefined => {
    if (!ORPYX_PORTAL_URL || !patient.patientId)
        return undefined;

    return `${ORPYX_PORTAL_URL}/patients/${patient.patientId}`;
};

export const PatientPortalLink = memo((props: PatientPortalLinkProps) => {
    const classes = usePatientPortalLinkStyle();

    const url = portalPatientUrl(props.patient);

    if (!url)
        return null;

    return (
        <a
            className={classes.root}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open this patient's record in the Orpyx Portal"
            id="patient-portal-link"
        >
            View in Orpyx Portal
            <OpenInNewIcon className={classes.icon}/>
        </a>
    );
});
